import { GET_LIST_CATEGORY, GET_LIST_CATEGORY_FAILURE, GET_LIST_CATEGORY_SUCCESS } from './actions';

// Define the state interface
interface CategoryState {
  loading: boolean;
  error: string;
  categories: any[];
}

// Define the action types (these should match the ones you already have in your actions file)
interface CategoryAction {
  type: string;
  payload?: any;
}

const initState: CategoryState = {
  loading: false,
  error: '',
  categories: [],
};

export default function categoryReducer(
  state: CategoryState = initState,
  { type, payload }: CategoryAction
): CategoryState {
  switch (type) {
    case GET_LIST_CATEGORY:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case GET_LIST_CATEGORY_FAILURE:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case GET_LIST_CATEGORY_SUCCESS:    
      return {
        ...state,
        categories: payload,
        loading: false,
      };
    default:
      return state;
  }
}
